export enum InboundEmailsPermissions {
  GET_INBOUND_EMAILS = 'inboundEmails.getInboundEmails',
  MANAGE_INBOUND_EMAILS = 'inboundEmails.manageInboundEmails',
}
